
import { Component, Vue, Prop } from 'nuxt-property-decorator';
import { Size } from '../types';
import { rem } from '../helpers';

@Component
export default class Tag extends Vue {
  @Prop({ type: String, default: 'md' }) readonly size!: 'sm' | 'md' | 'lg';

  Sizes = Size;

  get sizeMap() {
    return {
      sm: { '--height': rem(22) },
      md: { '--height': rem(24) },
      lg: { '--height': rem(28) },
    };
  }

  get sizingProperties() {
    return this.sizeMap[this.size];
  }

  get tagClassNames() {
    return [`-${this.Sizes[this.size]}`];
  }
}
